module.exports = __webpack_public_path__ + "static/media/Quiz.c50f2b1f.png";